const config = {
  set_title: '版面設置',
  set_tip: '用戶可透過使用習慣修改此頁面需要顯示的資料',
  save_btn: '儲存',
  data_id: '申請編號',
  data_group: '小組',
  date: '日期',
  data_address: '面試地點',
  data_parents_info: '家長資料',
  data_birth: '出生證明',
  data_receipt: '收據',
  data_parents_contact: '家長聯絡資料',
  data_time: '面試時段',
  data_date: '面試日期',
  data_rating: '評分情況',
  data_attendance: '出席情況',
  table_title: '查詢申請資料',
  table_btn: '版面設置',
  table_search_student: '搜索面試學生',
  table_search_date: '面試日期',
  table_search_timeFrame: '面試時段',
  table_search_place: '面試地點',
  data_name: '姓名',
  data_interview_no: '面試編號',
  data_sex: '性別',
  data_operation: '操作',
  open_btn: '打開',
  edit_btn: '更改資料',
  phase: '請選擇面試階段',
  Name_interview: '面試名稱',
  group: '面試組別',
  previous: '取消',
  determine: '確定',
  interview_system: '面試系統',
  NameofStudent: '學生姓名',
  Confirm_attend: '確認出席',
  Application_number: '申請編號',
  interview_panel: '面試小組',
  interview_time: '面試時間',
  select_time: '選擇時間',
  returns: '返回',
  attendance: '出席',
  Parent_Contact_Number: '家長聯絡電話',
  birth_certificate: '出生證明',
  open: '打開',
  receipt: '收據',
  attend_time: '出席時間',
  name: '名稱：',
  telephone: '聯絡電話：',
  FATHER: '父親',
  MOTHER: '母親',
  GUARDIAN: '監護人',

  select_view_time: '選擇面試時間',
  selected: '已選擇',
  confirm_time: '確認',

  not_info: '暫時沒有資料',
  not_device: '找不到設備,請使用相冊功能',
  Cancel_attendance: '取消出席',
  Cancellation_succeeded: '取消成功',
  Cancel_failed: '取消失敗',
  Success_attend: '成功出席',
  Attend_failed: '出席失敗',
  location: '面試地點',
  total_score: '總分',

  Scan_successfully: '掃碼成功,正在前往',
  Scan_loading: '掃瞄進行中，請稍後...',
  Scan_failed: '讀取失敗,請重試',
  Scan_error: '該二維碼不在此面試階段',
  Invalid_token: 'token錯誤,請重試',
  Incorrect_QR_code: '二維碼不正確',
  employee: '{{value}}是PLK員工嗎?',
  graduate: '{{value}}是PLK畢業生嗎?',
  WorkPlace: '工作場所',
  NameEnglish: '英文名稱：',
  career: '職業：',
  Yes: '是',
  no: '否',
  Parent: '家長',
  Setscore: '評分',
  Attend: '是否出席',
  not_found: '沒有資料',
  ConnectPrinter: '連接打印機',
  PrintLabel: '打印Label',
  logout: '登出',
  preview: '預覽',
  student_file: '學生檔案',
  Row: '第 {{from}} 項至第 {{to}} 項, 共 {{ value }} 項 ',
  Page: '每頁行數：',
  attendance_status: '出席狀態',
  not_present: '未出席',
};

export default config;
